var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon48PxPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,255.9978,255.9978",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(16,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11.5c-4.065,0 -7.5,-1.832 -7.5,-4c0,-2.168 3.435,-4 7.5,-4c4.065,0 7.5,1.832 7.5,4c0,2.168 -3.435,4 -7.5,4z",
    fill: "#8993be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,4c4.125,0 7,1.845 7,3.5c0,1.655 -2.875,3.5 -7,3.5c-4.125,0 -7,-1.845 -7,-3.5c0,-1.655 2.875,-3.5 7,-3.5M8,3c-4.418,0 -8,2.015 -8,4.5c0,2.485 3.582,4.5 8,4.5c4.418,0 8,-2.015 8,-4.5c0,-2.485 -3.582,-4.5 -8,-4.5z",
    fill: "#8993be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.525,7c0.233,0 0.399,0.076 0.455,0.147c0.01,0.013 0.037,0.047 0.009,0.165c-0.088,0.369 -0.163,0.688 -1.26,0.688h-0.095l0.188,-1h0.703M4.525,6h-1.533l-0.75,4h0.978l0.188,-1h0.321c1.256,0 1.978,-0.381 2.233,-1.457c0.22,-0.924 -0.51,-1.543 -1.437,-1.543zM12.525,7c0.233,0 0.399,0.076 0.455,0.147c0.01,0.013 0.037,0.047 0.009,0.165c-0.088,0.369 -0.163,0.688 -1.26,0.688h-0.094l0.188,-1h0.702M12.525,6h-1.534l-0.75,4h0.978l0.188,-1h0.321c1.256,0 1.978,-0.381 2.233,-1.457c0.221,-0.924 -0.509,-1.543 -1.436,-1.543z",
    fill: "#232531"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#232531"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.689,6.242c-0.189,-0.172 -0.521,-0.242 -1.016,-0.242h-0.629l0.258,-1h-1.007l-0.836,4h1.019l0.39,-2h0.176h0.629c0.069,0 0.128,0.002 0.177,0.004l-0.382,1.996h1.04l0.348,-1.926c0.074,-0.382 0.018,-0.662 -0.167,-0.832z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon48PxPhp);
export default __webpack_public_path__ + "static/media/icon-48px-php.7af60f177f855b217996db1c1e20a1bc.svg";
export { ForwardRef as ReactComponent };